<div class="row sub-change__row">
  <div class="col-12 sub-change__intro">
    <h3 *appApplyIfNotEmpty="translationService.getTranslation('sub_change_intro')"
        [innerHTML]="translationService.getTranslation('sub_change_intro')"
        class="sub-change__intro-title"></h3>
  </div>
  <div class="col-12 sub-change__description">
    <p [innerHTML]="translationService.getTranslation('sub_change_description')"
        class="sub-change__description-title"></p>
  </div>
</div>
<div class="row sub-change__row">
  <div class="col-12 sub-change__content">
    @if (isLoadingSub) {
      <div style="text-align: center;" class="sub-change__loading">
        <app-loading-spinner class="sub-change__spinner"></app-loading-spinner>
      </div>
    }
    <app-general-errors [errors]="errorsArr" class="sub-change__errors"></app-general-errors>
    @if (!isLoadingSub && subs.length == 0 && !foundDigitalSubscription) {
      <div class="mt-3 sub-change__no-subs" [innerHTML]="translationService.getTranslation('intro_noSubs')"></div>
    }
    @if (!isLoadingSub && subs.length == 0 && foundDigitalSubscription) {
      <div class="mt-3 sub-change__no-subs-digital"
           [innerHTML]="translationService.getTranslation('intro_noSubs_onlyDigital')"></div>
    }
    @if (!isLoadingSub && subs.length > 0) {
      <div class="row">
      @for (sub of subs; track sub) {
        <div class="col-12 col-md-6 col-lg-4 mt-3">
          <mat-card appearance="outlined" class="mt-3 sub-change__card">
            <div class="--row m-3 sub-change__card-row">
              <div tabindex="0" class="col-12 sub-change__card-info">
                <mat-card-title class="sub-change__card-title">{{ sub.productDescription }}</mat-card-title>
                @if (sub.subId) {
                  <mat-card-subtitle [innerHTML]="translationService.getTranslation('order_id') + ': ' + sub.subId"
                                     class="sub-change__card-subtitle sub-change__card-subtitle--order-id">
                  </mat-card-subtitle>
                }
                @if (sub.variantDescription) {
                  <mat-card-subtitle
                    [innerHTML]="translationService.getTranslation('order_edition') + ': ' + sub.variantDescription"
                    class="sub-change__card-subtitle sub-change__card-subtitle--edition">
                  </mat-card-subtitle>
                }
                @if (sub.validDate) {
                  <mat-card-subtitle [innerHTML]="translationService.getTranslation('period') + ': ' +
                    (sub.validDate.validFrom | date: translationService.getTranslation('dateFormat')) + ' - ' +
                    ((sub.validDate.validUntil) ? (sub.validDate.validUntil | date: translationService.getTranslation('dateFormat')) : translationService.getTranslation('subscription_endless'))"
                                     class="sub-change__card-subtitle sub-change__card-subtitle--period">
                  </mat-card-subtitle>
                }
                @if (sub.curDelivery) {
                  <mat-card-subtitle class="sub-change__card-subtitle sub-change__card-subtitle--delivery">
                    {{ sub.curDelivery.person.addressCodeDescription }}
                    {{ sub.curDelivery.person.firstname }}
                    {{ sub.curDelivery.person.lastname }},
                    {{ sub.curDelivery.address.city }},
                    {{ sub.curDelivery.address.street }} {{ sub.curDelivery.address.houseno | houseNoPipe }}
                  </mat-card-subtitle>
                }
              </div>
              <div class="col-12 sub-change__card-actions">
                @let onlinePayment = isOnlinePayment(sub);
                <mat-card-actions class="card-actions sub-change__actions">
                  <button ngSkipHydration mat-raised-button color="primary" (click)="onNewSubChange(sub)"
                          [innerHTML]="translationService.getTranslation('button_new_sub_change')"
                          [disabled]="onlinePayment"
                          class="mt-2 sub-change__actions-btn sub-change__actions-btn--new"></button>
                </mat-card-actions>

                @if (onlinePayment) {
                  <p *appApplyIfNotEmpty="translationService.getTranslation('subChange_impossible')"
                     class="mb-0 sub-change__warning text-warning" id="sub-change-warning"
                     [innerHTML]="translationService.getTranslation('subChange_impossible')"></p>
                }
              </div>
            </div>
            @if (sub && sub.subChanges && sub.subChanges.length > 0) {
              <mat-card-content class="sub-change__card-content">
                <mat-accordion multi class="sub-change__accordion">
                  @for (subChange of sub.subChanges; track subChange; let innerI = $index) {
                    <mat-expansion-panel class="sub-change__expansion-panel">
                      @if (subChange.state != 3) {
                        <mat-expansion-panel-header class="sub-change__expansion-header">
                          <mat-panel-title
                            [innerHTML]="translationService.getTranslation('label_' + subChange.changeType.toString() + '_description')"
                            class="sub-change__panel-title"></mat-panel-title>
                          <mat-panel-description class="sub-change__panel-description">
                            {{ subChange.validDate.validFrom | date: translationService.getTranslation('dateFormat') }}
                            {{
                              (subChange.validDate.validUntil && subChange.validDate.validUntil != subChange.validDate.validFrom) ?
                                ' - ' + (subChange.validDate.validUntil | date: translationService.getTranslation('dateFormat')) : ''
                            }}
                          </mat-panel-description>
                        </mat-expansion-panel-header>
                      }
                      @if (subChange.state != 3) {
                        <mat-action-row class="sub-change__action-row">
                          @if (!subChange.outdated) {
                            <button class="me-3 sub-change__action-btn sub-change__action-btn--delete"
                                    mat-raised-button color="primary" (click)="onDelete(sub, subChange)"
                                    [innerHTML]="translationService.getTranslation('button_delete')"></button>
                          }
                          @if (!subChange.outdated) {
                            <button class="mr-3 sub-change__action-btn sub-change__action-btn--edit"
                                    mat-raised-button (click)="onEdit(sub, subChange)">
                              {{ translationService.getTranslation('button_edit') }}
                            </button>
                          }
                        </mat-action-row>
                      }
                      @if (subChange.state != 3) {
                        <ng-template matExpansionPanelContent>
                          @if (subChange.address && subChange.person && subChange.person.lastname) {
                            <div class="row sub-change__address-row">
                              <div class="col-12 sub-change__address-label"
                                   [innerHTML]="translationService.getTranslation('address_delivery')"></div>
                              <div class="col-12 sub-change__address-detail">
                                <app-address-detail [address]="subChange.address"
                                                    [person]="subChange.person"
                                                    class="sub-change__address-detail-component"></app-address-detail>
                              </div>
                            </div>
                          }
                          @if (subChange.reasonMemo) {
                            <div class="row sub-change__reason-row">
                              <div class="col-12 sub-change__reason-label"
                                   [innerHTML]="translationService.getTranslation('complaint_reasonMemo')"></div>
                              <div class="col-12 sub-change__reason-memo">
                                {{ subChange.reasonMemo }}
                              </div>
                            </div>
                          }
                        </ng-template>
                      }
                    </mat-expansion-panel>
                  }
                </mat-accordion>
              </mat-card-content>
            }
          </mat-card>
        </div>
      }
      </div>
    }
  </div>
</div>
